export const ICELAND_COUNTRY_CODE = 'is';
export const SWISS_COUNTRY_CODE = 'ch';
